var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,257.13l-15.28-4.72a1,1,0,0,1,.34-1.94l17.62.93c-4.16-7.23-6.62-11.75-9.42-17.41a1,1,0,0,1,1.63-1.1c3.76,4.23,6.91,7.66,11.95,13.07,1.2-7,2.6-13.45,4.34-19.92a1,1,0,0,1,1.95.34,137.88,137.88,0,0,0-.51,15.68l.48.17q6.34-7.24,13.31-13.91a1,1,0,0,1,1.45,1.34,183,183,0,0,0-12.43,17.85q9.06-3.42,18.22-6.63a1,1,0,0,1,.82,1.8c-6.33,3.59-12.58,7.26-18.84,11.06l16.11,5.13a1,1,0,0,1-.36,1.94l-16.55-1c3.27,3.83,5.55,6.46,8.19,9.43a1,1,0,0,1-1.29,1.49c-3.33-2.21-6.25-4.17-10.52-7,.44,3.4.81,6,1.26,8.62a1,1,0,0,1-1.9.53c-1.11-2.83-2.12-5.64-3.4-9.38-4.81,23-3.57,45.33,1.09,68.21l-5.77-1a179,179,0,0,1,2.7-67.52c-2.89,3-5,5.23-7,7.49a1,1,0,0,1-1.59-1.17c1.36-2.26,2.83-4.55,4.81-7.52-5.15,1.13-8.67,1.91-12.56,2.79a1,1,0,0,1-.66-1.86C391.78,261.05,395.11,259.45,400,257.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.87,265.08l11.74-6.22a1.33,1.33,0,0,0-.95-2.47L388.17,260c2.36-6.8,3.86-11.38,5.31-16.42a1.33,1.33,0,0,0-2.42-1.05c-2.38,4-4.65,7.6-8,12.91C381,250,379,244.94,376.68,240a1.33,1.33,0,0,0-2.49.89c1,3.92,1.83,7.87,2.47,11.74l-.44.26q-5.7-4.44-11.66-8.51a1.33,1.33,0,0,0-1.66,2.07q6.28,5.75,12,12.06-7.71-1.33-15.45-2.54a1.33,1.33,0,0,0-.63,2.57c5.7,2,11.36,4,17,6.13l-12.49,6.76a1.33,1.33,0,0,0,1,2.46l13.45-3.41c-1.95,3.41-3.44,6-5,8.58a1.33,1.33,0,0,0,2.08,1.63l7.17-7.06c.12,2,.22,3.78.28,5.42a1.33,1.33,0,0,0,2.64.17c.33-2,.65-4.08,1-6.57,9,21.71,12,43.86,11.66,67.21l5.47-2.1a178.94,178.94,0,0,0-15.26-65.83c2.08,1.46,3.82,2.7,5.41,3.87a1.33,1.33,0,0,0,1.76-2c-1.08-1.15-2.27-2.37-3.64-3.77,4,.11,7.06.2,10,.3a1.33,1.33,0,0,0,.39-2.61C398.91,266.93,395.88,266.12,391.87,265.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.6,277.7l-8.76-4.65a.94.94,0,0,1,.67-1.74L415.3,274c-1.76-5.06-2.85-8.42-3.93-12.18a.94.94,0,0,1,1.71-.74c1.78,2.94,3.45,5.64,5.94,9.59,1.51-4.05,3.07-7.8,4.78-11.49a.94.94,0,0,1,1.76.63c-.77,3-1.4,6-1.88,8.91l.28.16q4.32-3.37,8.86-6.45a.94.94,0,0,1,1.16,1.48q-4.73,4.29-9,9,5.76-1,11.56-1.91a.94.94,0,0,1,.45,1.82q-6.37,2.21-12.71,4.58l9.3,5a.94.94,0,0,1-.68,1.74l-10-2.54c1.46,2.57,2.57,4.49,3.73,6.44a.94.94,0,0,1-1.47,1.15l-5.38-5.29c-.1,1.59-.17,2.95-.22,4.22a.94.94,0,0,1-1.87.12c-.25-1.51-.5-3.13-.78-5.06-6.58,15.83-8.72,32-8.5,49l-4-1.53a130.59,130.59,0,0,1,11.12-48c-1.61,1.14-3,2.1-4.18,3a.94.94,0,0,1-1.25-1.4c.85-.9,1.77-1.86,2.86-3l-7.55.22a.94.94,0,0,1-.28-1.85C407.31,279.08,409.57,278.48,412.6,277.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.91,382.23h29.82a3.94,3.94,0,0,0,3.94-3.7l3.16-51.44c.14-2.27-44.16-2.27-44,0L384,378.53A3.94,3.94,0,0,0,387.91,382.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.1,263.38a3,3,0,0,1-1.07-2.67l.67-5.7-1.53,2.65a3,3,0,0,1-4.43.9l-3-2.26,2.73,4.41a3,3,0,0,1-.6,3.88l-3.53,3,3.46-.79a3,3,0,0,1,3.54,2l1.19,3.64.76-3.87a3,3,0,0,1,3.81-2.31l2.33.68Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,253.56a2.17,2.17,0,0,0,.78-1.95l-.49-4.17,1.12,1.94a2.2,2.2,0,0,0,3.24.66l2.18-1.65-2,3.22a2.2,2.2,0,0,0,.44,2.83l2.58,2.22-2.53-.58a2.2,2.2,0,0,0-2.58,1.46l-.87,2.66-.56-2.83a2.21,2.21,0,0,0-2.78-1.69l-1.7.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.78,277.43a1.61,1.61,0,0,0,.56-1.41l-.35-3,.8,1.39a1.58,1.58,0,0,0,2.32.47l1.57-1.19L421.25,276a1.58,1.58,0,0,0,.31,2l1.85,1.59-1.81-.42a1.57,1.57,0,0,0-1.85,1l-.63,1.91-.4-2a1.58,1.58,0,0,0-2-1.21l-1.22.36Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.15,
    y: 135.66,
    width: 28.81,
    height: 7.73,
    rx: 1.32,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 145.24,
    width: 28.81,
    height: 7.73,
    rx: 1.32,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.5,
    y: 145.24,
    width: 28.81,
    height: 7.73,
    rx: 1.32,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.13,
    y: 189,
    width: 30.56,
    height: 8.2,
    rx: 1.32,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.13,
    y: 209.35,
    width: 30.56,
    height: 8.2,
    rx: 1.32,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 199.17,
    width: 30.56,
    height: 8.2,
    rx: 1.32,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.78,
    y: 199.17,
    width: 30.56,
    height: 8.2,
    rx: 1.32,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.12,
    y: 200.94,
    width: 31.55,
    height: 8.47,
    rx: 1.32,
    transform: "translate(789.79 410.35) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.75,
    y: 190.45,
    width: 31.55,
    height: 8.47,
    rx: 1.32,
    transform: "translate(809.06 389.37) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.73,
    y: 190.45,
    width: 31.55,
    height: 8.47,
    rx: 1.32,
    transform: "translate(743.01 389.37) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.45,
    y: 158.64,
    width: 33.2,
    height: 8.91,
    rx: 1.32,
    transform: "translate(196.1 326.19) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.96,
    y: 147.6,
    width: 33.2,
    height: 8.91,
    rx: 1.32,
    transform: "translate(227.11 304.11) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.21,
    y: 147.6,
    width: 33.2,
    height: 8.91,
    rx: 1.32,
    transform: "translate(157.62 304.11) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.65,
    y: 61.72,
    width: 1.35,
    height: 40.02,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.56 123.97 145.32 98.13 188.09 123.97 102.56 123.97",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.28 123.97 145.32 98.13 164.55 123.97 148.28 123.97",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 61.72,
    width: 1.35,
    height: 40.02,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.92 123.97 354.68 98.13 397.44 123.97 311.92 123.97",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.63 123.97 354.68 98.13 373.9 123.97 357.63 123.97",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.88,144.75h-5v-5a2.49,2.49,0,0,1,2.5-2.5h0a2.5,2.5,0,0,1,2.5,2.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.12,144.75h-5v-5a2.5,2.5,0,0,1,2.5-2.5h0a2.49,2.49,0,0,1,2.5,2.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.88,144.75h-5v-5a2.49,2.49,0,0,1,2.5-2.5h0a2.5,2.5,0,0,1,2.5,2.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.12,144.75h-5v-5a2.5,2.5,0,0,1,2.5-2.5h0a2.49,2.49,0,0,1,2.5,2.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 163.77,
    y: 144.19,
    width: 172.46,
    height: 94.83,
    rx: 5.64,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.77,
    y: 144.19,
    width: 172.46,
    height: 94.83,
    rx: 5.64,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.59,241.52H169.41a8.15,8.15,0,0,1-8.14-8.14V149.83a8.15,8.15,0,0,1,8.14-8.14H330.59a8.15,8.15,0,0,1,8.14,8.14v83.55A8.15,8.15,0,0,1,330.59,241.52ZM169.41,146.69a3.15,3.15,0,0,0-3.14,3.14v83.55a3.15,3.15,0,0,0,3.14,3.14H330.59a3.15,3.15,0,0,0,3.14-3.14V149.83a3.15,3.15,0,0,0-3.14-3.14Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.59,241.52H169.41a8.15,8.15,0,0,1-8.14-8.14V149.83a8.15,8.15,0,0,1,8.14-8.14H330.59a8.15,8.15,0,0,1,8.14,8.14v83.55A8.15,8.15,0,0,1,330.59,241.52ZM169.41,146.69a3.15,3.15,0,0,0-3.14,3.14v83.55a3.15,3.15,0,0,0,3.14,3.14H330.59a3.15,3.15,0,0,0,3.14-3.14V149.83a3.15,3.15,0,0,0-3.14-3.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.38,163.12c6.44.3,14.35,4.25,16,11.13,2,8.28-9,11.65-15.17,11.85-5.87.18-15.86-1.91-16.89-9-1.16-8.09,10.44-9.81,16.09-9.94a.38.38,0,0,0,0-.75c-5.88.14-17,1.8-17,9.75,0,8.25,11.47,10.92,17.78,10.73s16.53-3.27,16.14-11.21-9.94-12.95-16.94-13.27c-.49,0-.49.73,0,.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.63,206.23c.07,2.13.29,4.29.22,6.42,0,.63.7.25-.38.23s-2,.07-3.06.1l-7.83.27a28.45,28.45,0,0,0-3.06.11c-1.08.16-.35.26-.41-.06-.42-2.24-.17-4.83-.25-7.12a4.42,4.42,0,0,1,0-1.2c.15-.49-.59.31-.25.16a7.12,7.12,0,0,1,2.17-.08l13.19-.45c.48,0,.49-.77,0-.75l-15.49.53a.38.38,0,0,0-.37.38q.15,4.48.31,9a.38.38,0,0,0,.37.38l15.49-.54a.39.39,0,0,0,.38-.37l-.24-7c0-.48-.77-.48-.75,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.48,206.85c.1,2.94.71,6.25.31,9.15-.15,1.13.81.19-.69.48a30.17,30.17,0,0,1-4.36.15l-11.15.39c-1.42,0-2.93.24-4.36.15s-.44.49-.75-.24c-1.07-2.53-.25-7.38-.35-10.15,0-1,.15-1.89-.25-1.65.59-.36,2.36-.08,3.09-.1l18.79-.65c.48,0,.48-.77,0-.75l-22.07.76a.39.39,0,0,0-.38.38l.45,12.81a.36.36,0,0,0,.37.37l22.07-.76a.37.37,0,0,0,.37-.37c-.11-3.33-.23-6.65-.34-10,0-.48-.77-.48-.75,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.78,164.44a52,52,0,0,1,.2,5.85c-.13,1.84.81.47-.52,1-2.86,1.07-7.71.27-10.79.38l-14.12.48c-1.61.06-3.23.18-4.84.17-.27,0-1,.18-1.21,0-.73-.42.52.88,0-.12-.69-1.36-.15-4.46-.2-6,0-.38-.35-2.23-.09-2.55-.2.25-.37.49.23.22,2.44-1.12,7.55-.26,10.17-.35l21.47-.74c.48,0,.48-.77,0-.75l-32.25,1.11a.39.39,0,0,0-.38.38c.11,3.07.21,6.13.32,9.2a.38.38,0,0,0,.38.37L319.4,172a.38.38,0,0,0,.38-.37l-.25-7.16c0-.48-.77-.48-.75,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.76,176.63H281.85a.38.38,0,0,0,0,.75h42.91a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,184.93H299.52a.38.38,0,0,0,0,.75H321a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.12,188.24h-15.6a.38.38,0,0,0,0,.75h15.6a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,174.76H209.25a.38.38,0,0,0,0,.75H230.7a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.85,178.07h-15.6a.38.38,0,0,0,0,.75h15.6a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.85,197.12H299.4a.38.38,0,0,0,0,.75h21.45a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.12,213.38H299.4a.38.38,0,0,0,0,.75h10.72a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.24,209.31H184.51a.38.38,0,0,0,0,.75h10.73a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,209.5l-12.72,1c-.48,0-.49.79,0,.75l12.72-1c.48,0,.49-.79,0-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.21,192.43H249.48a.38.38,0,0,0,0,.75h11.73a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.85,210.41H299.4a.38.38,0,0,0,0,.75h21.45a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.92,189l-.3,8.73a.36.36,0,0,0,.37.37l19.33.67a.38.38,0,0,0,.37-.37l.39-11.23a.38.38,0,0,0-.38-.37l-19.32-.67c-.48,0-.48.73,0,.75l16.45.57c.62,0,2.09-.23,2.61.09s-.37-.7-.12-.11a3.37,3.37,0,0,1,0,1.22c-.44,2.88.54,6.4-.32,9.18-.21.68.75.1-.61.16-1.15,0-2.33-.08-3.48-.12l-10.1-.35c-1.27-.05-2.54-.11-3.82-.13s-.48.37-.56-.38c-.26-2.58.19-5.41.28-8a.38.38,0,0,0-.75,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.82,186.92a26.09,26.09,0,0,0-11.17,13.56c-.16.46.56.65.72.2a25.33,25.33,0,0,1,10.83-13.11c.41-.25,0-.9-.38-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,196.68c.33,1.94.67,3.89,1,5.83.05.31.43.33.63.17l4.83-4c.37-.31-.16-.84-.53-.53l-4.83,4,.62.16c-.33-1.94-.66-3.89-1-5.83-.08-.48-.8-.27-.72.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.83,184.26a20.91,20.91,0,0,1,10.52,9.27c.23.43.88.05.65-.38a21.67,21.67,0,0,0-11-9.61c-.45-.18-.64.54-.2.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.14,189.86c0,1.63,0,3.26,0,4.89l.56-.32-4.48-2.65a.37.37,0,0,0-.37.65l4.48,2.65a.38.38,0,0,0,.56-.33c0-1.63,0-3.26,0-4.89a.38.38,0,0,0-.75,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.09,190.54c.65,3.09,1.14,6.21,1.58,9.34.07.47.79.27.72-.2-.43-3.13-.92-6.25-1.58-9.34-.1-.47-.82-.27-.72.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.11,197.4c-.41,1.16-.82,2.31-1.22,3.47l.62-.16c-.84-1-1.69-2-2.54-3-.31-.37-.84.17-.53.53.85,1,1.7,2,2.54,3a.38.38,0,0,0,.63-.17l1.23-3.47c.16-.46-.57-.65-.73-.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.05,188.25h-6.63l.38.37V182l-.38.37h6.63l-.38-.37v6.62a.38.38,0,0,0,.75,0V182a.38.38,0,0,0-.37-.38h-6.63a.38.38,0,0,0-.37.38v6.62a.38.38,0,0,0,.37.38h6.63A.38.38,0,0,0,292.05,188.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.05,200.44h-6.63l.38.37v-6.62l-.38.37h6.63l-.38-.37v6.62a.38.38,0,0,0,.75,0v-6.62a.38.38,0,0,0-.37-.38h-6.63a.38.38,0,0,0-.37.38v6.62a.38.38,0,0,0,.37.38h6.63A.38.38,0,0,0,292.05,200.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.05,212.62h-6.63l.38.38v-6.63l-.38.38h6.63l-.38-.38V213a.38.38,0,0,0,.75,0v-6.63a.38.38,0,0,0-.37-.37h-6.63a.38.38,0,0,0-.37.37V213a.38.38,0,0,0,.37.37h6.63A.38.38,0,0,0,292.05,212.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.65,183.4a11,11,0,0,1,4.27,3.29.37.37,0,0,0,.58.07c2.16-2,4.85-3.91,7.77-4.4.48-.08.28-.81-.19-.73-3.08.53-5.05,2.56-7.57,4.13-.81.51-.06.23-.33,0-.52-.37-.94-1-1.46-1.39a12.81,12.81,0,0,0-2.7-1.64c-.43-.2-.81.45-.37.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.65,196.16a10.93,10.93,0,0,1,4.27,3.28.37.37,0,0,0,.58.08c2.16-2,4.85-3.91,7.77-4.4.48-.08.28-.81-.19-.73-3.08.52-5.05,2.56-7.57,4.13-.81.51-.06.23-.33,0-.52-.38-.94-1-1.46-1.39a12.85,12.85,0,0,0-2.7-1.65c-.43-.19-.81.45-.37.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.65,207.78a10.93,10.93,0,0,1,4.27,3.28.37.37,0,0,0,.58.08c2.16-2,4.85-3.91,7.77-4.4.48-.09.28-.81-.19-.73-3.08.52-5.05,2.56-7.57,4.13-.81.51-.06.23-.33,0-.52-.38-.94-1-1.46-1.39a12.85,12.85,0,0,0-2.7-1.65c-.43-.19-.81.45-.37.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.38,163.12c6.44.3,14.35,4.25,16,11.13,2,8.28-9,11.65-15.17,11.85-5.87.18-15.86-1.91-16.89-9-1.16-8.09,10.44-9.81,16.09-9.94a.38.38,0,0,0,0-.75c-5.88.14-17,1.8-17,9.75,0,8.25,11.47,10.92,17.78,10.73s16.53-3.27,16.14-11.21-9.94-12.95-16.94-13.27c-.49,0-.49.73,0,.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.63,206.23c.07,2.13.29,4.29.22,6.42,0,.63.7.25-.38.23s-2,.07-3.06.1l-7.83.27a28.45,28.45,0,0,0-3.06.11c-1.08.16-.35.26-.41-.06-.42-2.24-.17-4.83-.25-7.12a4.42,4.42,0,0,1,0-1.2c.15-.49-.59.31-.25.16a7.12,7.12,0,0,1,2.17-.08l13.19-.45c.48,0,.49-.77,0-.75l-15.49.53a.38.38,0,0,0-.37.38q.15,4.48.31,9a.38.38,0,0,0,.37.38l15.49-.54a.39.39,0,0,0,.38-.37l-.24-7c0-.48-.77-.48-.75,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.48,206.85c.1,2.94.71,6.25.31,9.15-.15,1.13.81.19-.69.48a30.17,30.17,0,0,1-4.36.15l-11.15.39c-1.42,0-2.93.24-4.36.15s-.44.49-.75-.24c-1.07-2.53-.25-7.38-.35-10.15,0-1,.15-1.89-.25-1.65.59-.36,2.36-.08,3.09-.1l18.79-.65c.48,0,.48-.77,0-.75l-22.07.76a.39.39,0,0,0-.38.38l.45,12.81a.36.36,0,0,0,.37.37l22.07-.76a.37.37,0,0,0,.37-.37c-.11-3.33-.23-6.65-.34-10,0-.48-.77-.48-.75,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.78,164.44a52,52,0,0,1,.2,5.85c-.13,1.84.81.47-.52,1-2.86,1.07-7.71.27-10.79.38l-14.12.48c-1.61.06-3.23.18-4.84.17-.27,0-1,.18-1.21,0-.73-.42.52.88,0-.12-.69-1.36-.15-4.46-.2-6,0-.38-.35-2.23-.09-2.55-.2.25-.37.49.23.22,2.44-1.12,7.55-.26,10.17-.35l21.47-.74c.48,0,.48-.77,0-.75l-32.25,1.11a.39.39,0,0,0-.38.38c.11,3.07.21,6.13.32,9.2a.38.38,0,0,0,.38.37L319.4,172a.38.38,0,0,0,.38-.37l-.25-7.16c0-.48-.77-.48-.75,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.76,176.63H281.85a.38.38,0,0,0,0,.75h42.91a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321,184.93H299.52a.38.38,0,0,0,0,.75H321a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.12,188.24h-15.6a.38.38,0,0,0,0,.75h15.6a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.7,174.76H209.25a.38.38,0,0,0,0,.75H230.7a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.85,178.07h-15.6a.38.38,0,0,0,0,.75h15.6a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.85,197.12H299.4a.38.38,0,0,0,0,.75h21.45a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.12,213.38H299.4a.38.38,0,0,0,0,.75h10.72a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.24,209.31H184.51a.38.38,0,0,0,0,.75h10.73a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231,209.5l-12.72,1c-.48,0-.49.79,0,.75l12.72-1c.48,0,.49-.79,0-.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.21,192.43H249.48a.38.38,0,0,0,0,.75h11.73a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.85,210.41H299.4a.38.38,0,0,0,0,.75h21.45a.38.38,0,0,0,0-.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.92,189l-.3,8.73a.36.36,0,0,0,.37.37l19.33.67a.38.38,0,0,0,.37-.37l.39-11.23a.38.38,0,0,0-.38-.37l-19.32-.67c-.48,0-.48.73,0,.75l16.45.57c.62,0,2.09-.23,2.61.09s-.37-.7-.12-.11a3.37,3.37,0,0,1,0,1.22c-.44,2.88.54,6.4-.32,9.18-.21.68.75.1-.61.16-1.15,0-2.33-.08-3.48-.12l-10.1-.35c-1.27-.05-2.54-.11-3.82-.13s-.48.37-.56-.38c-.26-2.58.19-5.41.28-8a.38.38,0,0,0-.75,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.82,186.92a26.09,26.09,0,0,0-11.17,13.56c-.16.46.56.65.72.2a25.33,25.33,0,0,1,10.83-13.11c.41-.25,0-.9-.38-.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191,196.68c.33,1.94.67,3.89,1,5.83.05.31.43.33.63.17l4.83-4c.37-.31-.16-.84-.53-.53l-4.83,4,.62.16c-.33-1.94-.66-3.89-1-5.83-.08-.48-.8-.27-.72.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.83,184.26a20.91,20.91,0,0,1,10.52,9.27c.23.43.88.05.65-.38a21.67,21.67,0,0,0-11-9.61c-.45-.18-.64.54-.2.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.14,189.86c0,1.63,0,3.26,0,4.89l.56-.32-4.48-2.65a.37.37,0,0,0-.37.65l4.48,2.65a.38.38,0,0,0,.56-.33c0-1.63,0-3.26,0-4.89a.38.38,0,0,0-.75,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.09,190.54c.65,3.09,1.14,6.21,1.58,9.34.07.47.79.27.72-.2-.43-3.13-.92-6.25-1.58-9.34-.1-.47-.82-.27-.72.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.11,197.4c-.41,1.16-.82,2.31-1.22,3.47l.62-.16c-.84-1-1.69-2-2.54-3-.31-.37-.84.17-.53.53.85,1,1.7,2,2.54,3a.38.38,0,0,0,.63-.17l1.23-3.47c.16-.46-.57-.65-.73-.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.05,188.25h-6.63l.38.37V182l-.38.37h6.63l-.38-.37v6.62a.38.38,0,0,0,.75,0V182a.38.38,0,0,0-.37-.38h-6.63a.38.38,0,0,0-.37.38v6.62a.38.38,0,0,0,.37.38h6.63A.38.38,0,0,0,292.05,188.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.05,200.44h-6.63l.38.37v-6.62l-.38.37h6.63l-.38-.37v6.62a.38.38,0,0,0,.75,0v-6.62a.38.38,0,0,0-.37-.38h-6.63a.38.38,0,0,0-.37.38v6.62a.38.38,0,0,0,.37.38h6.63A.38.38,0,0,0,292.05,200.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.05,212.62h-6.63l.38.38v-6.63l-.38.38h6.63l-.38-.38V213a.38.38,0,0,0,.75,0v-6.63a.38.38,0,0,0-.37-.37h-6.63a.38.38,0,0,0-.37.37V213a.38.38,0,0,0,.37.37h6.63A.38.38,0,0,0,292.05,212.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.65,183.4a11,11,0,0,1,4.27,3.29.37.37,0,0,0,.58.07c2.16-2,4.85-3.91,7.77-4.4.48-.08.28-.81-.19-.73-3.08.53-5.05,2.56-7.57,4.13-.81.51-.06.23-.33,0-.52-.37-.94-1-1.46-1.39a12.81,12.81,0,0,0-2.7-1.64c-.43-.2-.81.45-.37.64Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.65,196.16a10.93,10.93,0,0,1,4.27,3.28.37.37,0,0,0,.58.08c2.16-2,4.85-3.91,7.77-4.4.48-.08.28-.81-.19-.73-3.08.52-5.05,2.56-7.57,4.13-.81.51-.06.23-.33,0-.52-.38-.94-1-1.46-1.39a12.85,12.85,0,0,0-2.7-1.65c-.43-.19-.81.45-.37.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.65,207.78a10.93,10.93,0,0,1,4.27,3.28.37.37,0,0,0,.58.08c2.16-2,4.85-3.91,7.77-4.4.48-.09.28-.81-.19-.73-3.08.52-5.05,2.56-7.57,4.13-.81.51-.06.23-.33,0-.52-.38-.94-1-1.46-1.39a12.85,12.85,0,0,0-2.7-1.65c-.43-.19-.81.45-.37.65Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.13,386.68c0,17.57,29.56,21.86,66,21.86s51.09-4.29,51.09-21.86S410,347.76,373.49,347.76,303.13,369.12,303.13,386.68Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.13,386.68c0,17.57,29.56,21.86,66,21.86s51.09-4.29,51.09-21.86S410,347.76,373.49,347.76,303.13,369.12,303.13,386.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.37,362.07c-1.35,24.15,5.33,37.19,20.56,38s28.66-18.05,30-42.2-14-42.66-29.22-43.51S299.71,337.91,298.37,362.07Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.37,362.07c-1.35,24.15,5.33,37.19,20.56,38s28.66-18.05,30-42.2-14-42.66-29.22-43.51S299.71,337.91,298.37,362.07Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.74,349.84s14.17-1.8,15.42,3.2-23.37,2.25-28.31,7.25,16.06,7.57,11.49,10.56c-3.59,2.35-15.86-8.31-31.52-4.31s-17.9-7.81-16.15-18.78,3-22.76,7.75-21.86S351.57,348.38,372.74,349.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.67,367.75s-14.66-2.58-15.47,3.56S311.28,368.36,328.67,367.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,393.67c-4.12-4.83-6.36-12.32-6.76-22.35,1.88,19.1,13,31.48,57.25,33.47s54.13-11.25,58.88-9.66c2,.66,2,2.49,1.34,4.38-6.76,7-21.52,9-46.6,9C338.11,408.54,312.1,405.42,305,393.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.21,311.94a6.76,6.76,0,0,0-3.29,1.57c-1.23,1.24-4.82,1.11-4.82,1.11l-.36,4.07,8.2-.48Z",
    style: {
      fill: "#b25b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.14,287.62c1.07-.06,5.17,2.08,7.64,12.9s1.92,14.44,21.1,13.21l-.62,5.39s-16.62,1.78-21.58-2.2S344.18,287.85,348.14,287.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.66,300.93l.94,1.65s-1,10.19.93,14.89a5.92,5.92,0,0,1-.85-.55c-1.33-1.07-2.7-3.68-3.92-6.91Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.28,267.75s-.14,3.16-1.6,3.8,1.07,4.26.36,6.47-2.34,4.2-.59,7.16c0,0-.38-2.47.87-3.94,0,0-.52,4.14.82,4.23s1.6-1.12,3.8-.6.26-3.38.26-3.38a4.71,4.71,0,0,1,1.48,2.65c.59,2.07,6.41-.32,8.78.53s3-3.52,3-3.52,1.06,2.6.2,3.48a3.21,3.21,0,0,0,2.07-3A3.14,3.14,0,0,1,346,284s1.8-.13,1.35-3.61-3.16-4.48-3.87-7.24S334.1,265,334.1,265Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,278.38l7.42,4.83c0,5.21,3.73,4.93,3.73,4.93s.06,1.82-4.47,2.49a29.16,29.16,0,0,1-6.1.49C333.8,288.41,332.09,281.92,331,278.38Z",
    style: {
      fill: "#b25b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.89,286a6.67,6.67,0,0,1-.51-2.82l-6.62-4.31-.41.74S333.85,286.33,338.89,286Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.82,270.44c.75,6.05.94,8.63,4.2,11.55,4.9,4.4,12.16,2.16,13.24-4,1-5.54-.43-14.5-6.52-16.54a8.3,8.3,0,0,0-10.92,9Z",
    style: {
      fill: "#b25b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.19,274a13.16,13.16,0,0,0,2,3,2.1,2.1,0,0,1-1.74.45Z",
    style: {
      fill: "#9d2724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.86,270.85a.21.21,0,0,1-.11,0,.23.23,0,0,1,0-.34h0a2.83,2.83,0,0,1,2.36-1.11.24.24,0,0,1,.21.26.24.24,0,0,1-.26.22,2.35,2.35,0,0,0-1.94.94A.22.22,0,0,1,336.86,270.85Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.83,269.89a.16.16,0,0,1-.11-.05,2.39,2.39,0,0,0-2.11-.42.24.24,0,0,1-.31-.14h0a.24.24,0,0,1,.15-.31,2.84,2.84,0,0,1,2.56.49.24.24,0,0,1-.18.43Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.65,273.41c0,.49.32.87.64.85s.56-.43.53-.93-.32-.87-.64-.85S338.62,272.91,338.65,273.41Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.24,273.06c0,.49.32.87.64.86s.56-.44.53-.94-.32-.87-.64-.85S344.2,272.56,344.24,273.06Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.63,272.16l1.16-.41S345.24,272.71,344.63,272.16Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,272.51l1.16-.41S339.65,273.06,339,272.51Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.26,278.36a3.27,3.27,0,0,1-.35-.48.11.11,0,0,1,0-.16h0a.11.11,0,0,1,.16,0,3.25,3.25,0,0,0,2.45,1.54.13.13,0,0,1,.12.12.13.13,0,0,1-.13.12A3.3,3.3,0,0,1,339.26,278.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.85,261.87s3.25,3.6-.29,5-6.73,3.57-7.25,6.56a3.65,3.65,0,0,1-3.41,3.08s-4.68-5.94-1.66-12.17S338.62,259.69,339.85,261.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.46,262.8s3.91-6.05,10.46-3.12,6.84,7.9,5.2,7.41-4.27-1-6.15-4.37S330.46,262.8,330.46,262.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.42,274.2s3.23-.19,1.69,4.06A7.36,7.36,0,0,0,331.42,274.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.68,275.34a4.45,4.45,0,0,0,2.31,2.49c1.42.65,2.37-.57,2.17-2-.18-1.31-1.13-3.24-2.66-3.27a2,2,0,0,0-2,2A1.91,1.91,0,0,0,327.68,275.34Z",
    style: {
      fill: "#b25b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,325.88l-17.27-2.39a.54.54,0,0,1-.41-.78L367,301.83a1.5,1.5,0,0,1,1.56-.81l17.27,2.39a.53.53,0,0,1,.41.77l-10.73,20.89A1.5,1.5,0,0,1,374,325.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,325.88l-17.27-2.39a.54.54,0,0,1-.41-.78L367,301.83a1.5,1.5,0,0,1,1.56-.81l17.27,2.39a.53.53,0,0,1,.41.77l-10.73,20.89A1.5,1.5,0,0,1,374,325.88Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.66,326l-17.28-2.4a.53.53,0,0,1-.4-.77l10.72-20.89a1.54,1.54,0,0,1,1.57-.81l17.27,2.39a.54.54,0,0,1,.4.78l-10.72,20.88A1.53,1.53,0,0,1,374.66,326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.66,326l-17.28-2.4a.53.53,0,0,1-.4-.77l10.72-20.89a1.54,1.54,0,0,1,1.57-.81l17.27,2.39a.54.54,0,0,1,.4.78l-10.72,20.88A1.53,1.53,0,0,1,374.66,326Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.18,307.12l-2-.28a.06.06,0,0,1,0-.09l1.23-2.41a.19.19,0,0,1,.18-.09l2,.27a.06.06,0,0,1,0,.09L384.36,307A.18.18,0,0,1,384.18,307.12Z",
    style: {
      fill: "#263238",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.18,307.12l-2-.28a.06.06,0,0,1,0-.09l1.23-2.41a.19.19,0,0,1,.18-.09l2,.27a.06.06,0,0,1,0,.09L384.36,307A.18.18,0,0,1,384.18,307.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.42,313.75c-.29.81-1,1.41-1.51,1.34s-.73-.8-.44-1.61,1-1.42,1.51-1.35S373.72,312.93,373.42,313.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.91 391.41 394.19 404.86 398.9 403.19 397.51 389.53 390.91 391.41",
    style: {
      fill: "#b25b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.28,402.43l-5.7.11a.52.52,0,0,0-.51.42L392,408.31a.88.88,0,0,0,.68,1l.19,0c2.36-.09,4.46-.26,7.4-.31,3.47-.06,2.59.37,6.67.35,2.46,0,2.86-2.81,1.82-2.93-4.79-.51-6.16-1.93-8-3.6A2.13,2.13,0,0,0,399.28,402.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.32 397.45 397.51 389.53 390.91 391.41 392.81 399.19 398.32 397.45",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.23,326.23l7.53-2.9a44.85,44.85,0,0,1,6.42,9.58c2.46,5.2-9.38,5.2-9.38,5.2l-3.73-7Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.23,326.23l7.53-2.9a44.85,44.85,0,0,1,6.42,9.58c2.46,5.2-9.38,5.2-9.38,5.2l-3.73-7Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.61,324.55c2.13,11.79,5.95,9.68,5.95,9.68l-1.67,2.46-4.54.58-3.28-6.16-.84-4.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.02 366.95 426.56 379.53 430.27 376.74 421.01 362.75 416.02 366.95",
    style: {
      fill: "#b25b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.39,373.23l-4.52,3.52a.53.53,0,0,0-.18.64l2.15,5a.87.87,0,0,0,1.14.47l.17-.09c1.89-1.41,3.52-2.74,5.91-4.46,2.82-2,2.35-1.17,5.7-3.5,2-1.41.75-3.94-.18-3.45-4.22,2.3-6.26,1.72-8.75,1.41A2.13,2.13,0,0,0,428.39,373.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.77 373.81 426.23 370.63 421.01 362.75 416.02 366.95 421.77 373.81",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.94,331.32s-2.73,15.79,2.72,26,17.54,12.06,48.61-20.85c0,0,10.92,5.08,37.22,34.74l5.85-4.53s-22.89-37.18-33.95-46-35.62,16-38.73,14.6c-2.77-1.23-4.08-9.82-4.08-9.82Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.94,331.32s-2.73,15.79,2.72,26,17.54,12.06,48.61-20.85c0,0,10.92,5.08,37.22,34.74l5.85-4.53s-22.89-37.18-33.95-46-35.62,16-38.73,14.6c-2.77-1.23-4.08-9.82-4.08-9.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.62 371.17 419.04 373.31 425.94 367.58 424.76 364.5 416.62 371.17",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.85,357.57c6.28-4.33,14-11.11,23.42-21.11,0,0,9-3.33,12.13,3.09s5.17,52.82,5.17,52.82l-7.48,2.16s-13.38-41.88-13.3-44.64Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.85,357.57c6.28-4.33,14-11.11,23.42-21.11,0,0,9-3.33,12.13,3.09s5.17,52.82,5.17,52.82l-7.48,2.16s-13.38-41.88-13.3-44.64Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.4,339.55a6.62,6.62,0,0,0-2.23-2.62c2.67,1.41,6.42,4.81,6.86,12.91h0c-1.06-1-2.06-1.93-3-2.79A30.94,30.94,0,0,0,393.4,339.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.27,336.46a15.79,15.79,0,0,1,3.23-.74A69.11,69.11,0,0,1,372.23,352l-14.38,5.54C364.13,353.24,371.82,346.46,381.27,336.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.76 393.68 390.71 396.72 399.4 394.14 399.51 390.85 389.76 393.68",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.06,325.43s-2.24,3.63-25.91,7.23c0,0,1.05-7.31-1.45-17.77S316,294.59,325,292.05s24.6-7.77,25.94-2.11,3.78,8.13,3.68,12.64S351.21,310.37,355.06,325.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.12,313.79a1.92,1.92,0,0,0-.16-1.41c-.35-.69-1-1.58-1.87-1.49-1.44.14-1.82,1.17-2.18,2.5s-1.5,3.7-.2,4.52S382.85,318.27,384.12,313.79Z",
    style: {
      fill: "#b25b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.22,290.58s12.59.72,11.85-2.86c0,0-2.45-1.13-2-2.46s-6,.05-8.54-.31c-1-.15-.38,1.2-.45,2.64A8.6,8.6,0,0,1,330.22,290.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.23,317.35l9.21-.12,3.13-2.13,3.54-1.57.47,1.25s-11,12.79-15.25,11.67A59.51,59.51,0,0,0,328.23,317.35Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,314.72s-3.53,1.07-4.13-1.5c-.87-3.69-3.45-14-6.07-17.94C323,291,328.6,311.6,328.6,311.6l1.25,4.34,2,2.67,4.26-3Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.47,289.34s.44,2.41-9,2.19C333.45,291.53,344.48,294.17,342.47,289.34Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.3 309.45 351.17 308.43 350.45 308.86 351.3 309.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.3 309.45 351.17 308.43 350.45 308.86 351.3 309.45",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.68 296.79 342.8 296.13 343.56 295.68 344.19 295.88 351.07 307.35 351.22 308.46 350.46 308.92 349.55 308.26 342.68 296.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.68 296.79 342.8 296.13 343.56 295.68 344.19 295.88 351.07 307.35 351.22 308.46 350.46 308.92 349.55 308.26 342.68 296.79",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.12,
    y: 295.9,
    width: 0.88,
    height: 13.02,
    transform: "translate(-106.17 221.19) rotate(-30.94)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.8,292.66c-3.21.91-3.42,5.26-.49,15.95s5.08,17.5,10.74,14.93,12.21-9.45,12.21-9.45l-2.84-4.62s-9.23,7.94-11.16,6.42S327.73,291.28,322.8,292.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.21,311.29l3.9-3.28s-.57-6.56,1.55-6.64c1.74-.07,3.13,2,3.44,4.86s-2.9,4.62-2.9,4.62L343.43,315Z",
    style: {
      fill: "#b25b52"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.26,248.22s8.77-5.4,13.34,2.35c3.24,5.5,1.45,11,4,15.52,4,7,1.34,10.31-4.66,11.56s-15.63,1.08-14.3-5.92C261,264.57,254.32,248.12,261.26,248.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.84,263.84s.73,10.27,2.65,10.45a10.76,10.76,0,0,1-9,0l-.31-4.73Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.48 409.03 224.95 409.03 226.07 354.2 230.78 354.2 228.48 409.03",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.48 409.03 224.95 409.03 226.07 354.2 230.78 354.2 228.48 409.03",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "257.44 409.03 253.91 409.03 255.03 354.2 259.74 354.2 257.44 409.03",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "286.39 409.03 289.92 409.03 288.8 354.2 284.09 354.2 286.39 409.03",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "286.39 409.03 289.92 409.03 288.8 354.2 284.09 354.2 286.39 409.03",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 228.69,
    y: 354.2,
    width: 57.94,
    height: 5.13,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.69,
    y: 354.2,
    width: 57.94,
    height: 5.13,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.43 409.03 260.96 409.03 259.84 354.2 255.13 354.2 257.43 409.03",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.43 409.03 260.96 409.03 259.84 354.2 255.13 354.2 257.43 409.03",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.15,289.26h-9.6c-5,0-10.39,2.61-11.81,7.44-4,13.68-7,56.56-7,56.56h25.7a6.12,6.12,0,0,0,6.08-5.45l5.38-48.8A8.78,8.78,0,0,0,290.15,289.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.15,289.26h-9.6c-5,0-10.39,2.61-11.81,7.44-4,13.68-7,56.56-7,56.56h25.7a6.12,6.12,0,0,0,6.08-5.45l5.38-48.8A8.78,8.78,0,0,0,290.15,289.26Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.29,289.26h-9.6c-5,0-10.38,2.61-11.8,7.44-4,13.68-7,56.56-7,56.56h24.8a7.11,7.11,0,0,0,7.07-6.34L293,299A8.79,8.79,0,0,0,284.29,289.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.29,289.26h-9.6c-5,0-10.38,2.61-11.8,7.44-4,13.68-7,56.56-7,56.56h24.8a7.11,7.11,0,0,0,7.07-6.34L293,299A8.79,8.79,0,0,0,284.29,289.26Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.87,354.2H227.31a6.27,6.27,0,0,1-6.27-6.27h0a6.27,6.27,0,0,1,6.27-6.27h37.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.87,354.2H227.31a6.27,6.27,0,0,1-6.27-6.27h0a6.27,6.27,0,0,1,6.27-6.27h37.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.82,354.2H263.57a6,6,0,0,1-6-6v-.54a6,6,0,0,1,6-6h24.25a6.27,6.27,0,0,1,6.27,6.27h0A6.27,6.27,0,0,1,287.82,354.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.82,354.2H263.57a6,6,0,0,1-6-6v-.54a6,6,0,0,1,6-6h24.25a6.27,6.27,0,0,1,6.27,6.27h0A6.27,6.27,0,0,1,287.82,354.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.61,288s.84,9.13-3.47,13c-3.92,3.52-10.25,5.25-10.25,5.25l-5.58-1.63a1.37,1.37,0,0,0-1.44.43l-2.49,3a1.43,1.43,0,0,0,.28,2h0a1.45,1.45,0,0,0,1.07.3l2.89-.35a24.4,24.4,0,0,0,3.52.43,18.62,18.62,0,0,0,2.63-.74s9.95-.86,14.19-5.1,5.31-13.05,5.31-13.05Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.3 385.21 223.95 405.17 228.42 405.17 230.51 384.85 223.3 385.21",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.88,403.12l5.09,0a.46.46,0,0,1,.46.37l1.06,4.79a.79.79,0,0,1-.6.94l-.16,0c-2.12,0-4-.16-6.65-.16-3.12,0-2.33.36-6,.41-2.21,0-2.61-2.49-1.67-2.61,4.29-.53,5.52-1.83,7.18-3.36A1.88,1.88,0,0,1,223.88,403.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.87 400.79 229.37 395.9 223.65 395.9 223.81 400.79 228.87 400.79",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.59,310.2s13.92,31.63.55,31.63H237.56s-1.67,8.41-7.68,54.64h-6.45s-1.08-54.15,2.49-62.22c2.79-6.33,20.71-10.86,29.19-12.52a5.43,5.43,0,0,0,4.34-4.59l1.88-7.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.59,310.2s13.92,31.63.55,31.63H237.56s-1.67,8.41-7.68,54.64h-6.45s-1.08-54.15,2.49-62.22c2.79-6.33,20.71-10.86,29.19-12.52a5.43,5.43,0,0,0,4.34-4.59l1.88-7.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.19 395.36 222.71 398.87 230.38 398.87 231.09 395.36 222.19 395.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.19 395.36 222.71 398.87 230.38 398.87 231.09 395.36 222.19 395.36",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.72 385.22 237.47 404.91 241.74 404.9 244.81 384.86 236.72 385.22",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.37 400.79 243.12 395.9 237.12 395.9 237.31 400.79 242.37 400.79",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.56,403.12l5.1,0a.47.47,0,0,1,.46.37l1,4.79a.78.78,0,0,1-.59.94l-.17,0c-2.12,0-4-.16-6.64-.16-3.12,0-2.33.36-6,.41-2.2,0-2.6-2.49-1.67-2.61,4.29-.53,5.53-1.83,7.19-3.36A1.85,1.85,0,0,1,237.56,403.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.63,310.75s1,0,2.5,7.47c1.91,9.49,4.68,23.61-4.43,23.61H251.17s-1.44,3.43-7.72,54.64H237s-3.58-54.8,0-62.87c2.75-6.22,16.41-9.07,23.93-10.05a4.45,4.45,0,0,0,4-4.16c.06-2.26-.27-9-.27-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.71 395.36 236.45 398.87 243.89 398.87 244.6 395.36 235.71 395.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.71 395.36 236.45 398.87 243.89 398.87 244.6 395.36 235.71 395.36",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.36,274.34c-3.6-.54-5.63,8.32-5.82,16.68l8.54,2S264.09,275.36,257.36,274.34Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.36,274.34c-3.6-.54-5.63,8.32-5.82,16.68l8.54,2S264.09,275.36,257.36,274.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.64,314.72a122.85,122.85,0,0,0-1.38-13.43c-1.35-8.6-3.67-18.27-2.88-24.39a3.17,3.17,0,0,1,3.26-2.79H282a2.65,2.65,0,0,1,2.59,2.84c-.8,6.56-2.83,22.88.26,38.29C284.84,315.24,267,316.66,259.64,314.72Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.9,285.8s1.55,10.62-3.13,13.61-14.92,6.09-14.92,6.09l-6.33-1.34a.79.79,0,0,0-.84.35l-2.54,4.1a.85.85,0,0,0,.09,1h0a.88.88,0,0,0,.76.31l3.83-.39a18.17,18.17,0,0,0,2.66.44,21.13,21.13,0,0,0,3.29-.77s14.63-1.43,19.1-5.89,5-13.74,5-13.74Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.82,274.31c-4.54-.54-3.34,9.6-3.89,16.71l8.48,1S289.57,275.11,282.82,274.31Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.82,274.31c-4.54-.54-3.34,9.6-3.89,16.71l8.48,1S289.57,275.11,282.82,274.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.78,274.77s-.88,7.57,9.13.82a1.57,1.57,0,0,0,.55-1.95,7.41,7.41,0,0,1-.73-3,.86.86,0,0,0-1.33-.68,10.42,10.42,0,0,1-6.8,1.75.87.87,0,0,0-.91,1.11A3.92,3.92,0,0,1,263.78,274.77Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.78,274.77s-.88,7.57,9.13.82a1.57,1.57,0,0,0,.55-1.95,7.41,7.41,0,0,1-.73-3,.86.86,0,0,0-1.33-.68,10.42,10.42,0,0,1-6.8,1.75.87.87,0,0,0-.91,1.11A3.92,3.92,0,0,1,263.78,274.77Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,265.32h0c-.09-.89-.13-1.48-.13-1.48l-6.62,5.72.16,2.5C266.29,271.91,269.09,270.68,271,265.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.38,255.59c.53,5.85.88,8.32-1.59,11.74-3.71,5.15-11,4.53-13.28-1-2-5-2.58-13.73,2.73-16.91a8,8,0,0,1,12.14,6.21Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.06,261.12a13,13,0,0,1-1.14,3.31,2.05,2.05,0,0,0,1.73,0Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7,257.44a.24.24,0,0,0,.09-.08.23.23,0,0,0,0-.32h0a2.73,2.73,0,0,0-2.46-.5.24.24,0,0,0-.14.3.23.23,0,0,0,.29.14,2.26,2.26,0,0,1,2,.44A.27.27,0,0,0,262.7,257.44Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.58,258.67a.28.28,0,0,1-.12,0,.24.24,0,0,1-.06-.32h0a2.73,2.73,0,0,1,2.18-1.24.24.24,0,0,1,0,.47,2.31,2.31,0,0,0-1.8,1A.2.2,0,0,1,254.58,258.67Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.24,259.75c.08.47-.1.89-.41.95s-.62-.28-.7-.75.09-.89.4-.95S262.15,259.28,262.24,259.75Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.92,260.71c.09.46-.09.89-.4.94s-.62-.27-.71-.75.1-.89.41-.94S256.84,260.23,256.92,260.71Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.35,260l-1.18-.12S255.91,260.61,256.35,260Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.67,259l-1.19-.12S261.22,259.66,261.67,259Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.45,260a4.27,4.27,0,0,1-1.66,2.83c-1.21.9-2.35-.05-2.46-1.47s.4-3.29,1.83-3.63a1.93,1.93,0,0,1,2.29,2.27Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.27,266.83a3,3,0,0,1-.52.11.1.1,0,0,1-.12-.08h0a.12.12,0,0,1,.1-.12,2.83,2.83,0,0,0,2.11-1.44.11.11,0,0,1,.14-.06.11.11,0,0,1,0,.14A3,3,0,0,1,261.27,266.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.41,251.48s-1.6,2.5-.37,4.25-7.18-1.91-9.34,1.92c0,0-2.75-11.83,9.71-10.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,250.73s-.93,4.75,2.16,6.21,3,5.38,5.77,4.72c4-1,1.14-13.09-5.34-14.4C260.82,246.28,263,250.73,263,250.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.66 409.86 172.21 409.86 170.7 318.6 177.17 318.6 175.66 409.86",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.66 409.86 172.21 409.86 170.7 318.6 177.17 318.6 175.66 409.86",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.72 409.86 210.27 409.86 208.76 318.6 215.23 318.6 213.72 409.86",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.72 409.86 210.27 409.86 208.76 318.6 215.23 318.6 213.72 409.86",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.93,
    y: 317.07,
    width: 65.07,
    height: 7.14,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.93,
    y: 317.07,
    width: 65.07,
    height: 7.14,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 317.07,
    width: 38.16,
    height: 7.14,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 317.07,
    width: 38.16,
    height: 7.14,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.79 409.86 275.34 409.86 273.83 318.6 280.3 318.6 278.79 409.86",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.79 409.86 275.34 409.86 273.83 318.6 280.3 318.6 278.79 409.86",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.62,
    y: 312.48,
    width: 54.63,
    height: 6.12,
    rx: 2.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.62,
    y: 312.48,
    width: 54.63,
    height: 6.12,
    rx: 2.65,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.34,
    y: 312.48,
    width: 72.79,
    height: 6.12,
    rx: 2.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.34,
    y: 312.48,
    width: 72.79,
    height: 6.12,
    rx: 2.65,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.73 409.86 237.28 409.86 235.77 318.6 242.24 318.6 240.73 409.86",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.73 409.86 237.28 409.86 235.77 318.6 242.24 318.6 240.73 409.86",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.56,312.48a1,1,0,0,1,0-2h27.7a1,1,0,1,1,0,2Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.56,312.48a1,1,0,0,1,0-2h27.7a1,1,0,1,1,0,2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.91,310.72l-3.68-26.24a2.08,2.08,0,0,0-2-1.75H226.7v29.74h7.71A1.48,1.48,0,0,0,235.91,310.72Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.89,312.47H201.57a2.09,2.09,0,0,1-2-1.75l-3.68-26.24a1.48,1.48,0,0,1,1.5-1.75h31.32a2.08,2.08,0,0,1,2,1.75l3.69,26.24A1.49,1.49,0,0,1,232.89,312.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.89,312.47H201.57a2.09,2.09,0,0,1-2-1.75l-3.68-26.24a1.48,1.48,0,0,1,1.5-1.75h31.32a2.08,2.08,0,0,1,2,1.75l3.69,26.24A1.49,1.49,0,0,1,232.89,312.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.67,296.88a1.36,1.36,0,0,1-1.37,1.6,1.9,1.9,0,0,1-1.83-1.6,1.35,1.35,0,0,1,1.38-1.59A1.9,1.9,0,0,1,216.67,296.88Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.67,304.87c-3.76,21.95,22.45,10.44,32.9,10.7a6,6,0,0,1,2,.39l3.22,13.93-3.13,14.42-7.31,11.55H104.81L71.92,333.61,63.57,307.5l2.35-42.29,1-6.79s1,8.36,24,6.27,41-9.49,46.2-2.09C143.45,271.48,125.16,290.35,122.67,304.87Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.83 340.79 156.83 349.01 143.71 354.3 117.87 352.93 111.07 344.31 113.95 339.81 130.59 339.81 156.83 340.79",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 367.67,
    width: 7.9,
    height: 35.96,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 367.67,
    width: 7.9,
    height: 35.96,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.07 400.36 105.08 400.36 80.6 404.99 80.6 409.07 85.64 409.07 105.08 405.4 117.07 405.4 136.51 409.07 141.55 409.07 141.55 404.99 117.07 400.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.07 400.36 105.08 400.36 80.6 404.99 80.6 409.07 85.64 409.07 105.08 405.4 117.07 405.4 136.51 409.07 141.55 409.07 141.55 404.99 117.07 400.36",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.51,410.85h5a1.23,1.23,0,0,0,0-2.46h-5a1.23,1.23,0,0,0,0,2.46Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6,410.85h5a1.23,1.23,0,0,0,0-2.46h-5a1.23,1.23,0,0,0,0,2.46Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.12,
    y: 367.67,
    width: 7.9,
    height: 8.14,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.78,345.89H106.51V335.7h47.27a5.1,5.1,0,0,1,5.1,5.09h0A5.1,5.1,0,0,1,153.78,345.89Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.78,345.89H106.51V335.7h47.27a5.1,5.1,0,0,1,5.1,5.09h0A5.1,5.1,0,0,1,153.78,345.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.17,272.2s6,17,11,17.36,11-8.72,11-8.72l2.47-6.42,5-.42v8.06l-5.11,2.56s-7.81,12.83-13.87,12.51-12.18-9.7-13.42-14.48C110.55,280,111,274.55,114.17,272.2Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.69 286.18 146.48 271.36 139.62 270.89 139.41 285.82 144.69 286.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.69 286.18 146.48 271.36 139.62 270.89 139.41 285.82 144.69 286.18",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.68,
    y: 268.99,
    width: 6.87,
    height: 2.14,
    transform: "translate(18.44 -8.99) rotate(3.85)",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19,267.53h6.09a.39.39,0,0,1,.39.39V269a0,0,0,0,1,0,0H139.8a0,0,0,0,1,0,0v-1.07A.39.39,0,0,1,140.19,267.53Z",
    transform: "matrix(1, 0.07, -0.07, 1, 18.32, -9.01)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.58,287.15s-6.49-10.72-2.34-15.8S120.72,283,120.72,283Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.58,287.15s-6.49-10.72-2.34-15.8S120.72,283,120.72,283Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.32 286.39 112.55 288.2 121.65 283.5 120.8 281.6 111.32 286.39",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.32 286.39 112.55 288.2 121.65 283.5 120.8 281.6 111.32 286.39",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.06,328.12s-8.13-28.46,1.41-56.77c0,0,12.37-5.76,30-1.53a3.7,3.7,0,0,1,2.73,4.54c-1.76,6.87-4.49,23.24,2.1,43.93A79.36,79.36,0,0,1,80.06,328.12Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.06,328.12s-8.13-28.46,1.41-56.77c0,0,12.37-5.76,30-1.53a3.7,3.7,0,0,1,2.73,4.54c-1.76,6.87-4.49,23.24,2.1,43.93A79.36,79.36,0,0,1,80.06,328.12Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.54,268.4l6,5.17L105,270.5c-1.31-1-1-3.18-.22-5.56l-8.47-6.69C96.72,261.39,97,265.7,95.54,268.4Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.03 335.21 150.04 339.69 148.8 344.35 137.04 341.93 139.03 335.21",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.42,319.31s52.71-18.26,57.06-1.48-35.6,28.35-56.53,27.65S101.42,319.31,101.42,319.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.42,319.31s52.71-18.26,57.06-1.48-35.6,28.35-56.53,27.65S101.42,319.31,101.42,319.31Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.61,321,115,337.32l4.08,6.7s-2.47.82-5.89-7.37l15.83-10.46s-5-.5-4.83-1.27c.21-1.27,11.09-3.7,16.05-4.74A.46.46,0,0,1,140.61,321Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.1,336.6l4.43,7.52A84.06,84.06,0,0,1,102,345.48a15.32,15.32,0,0,1-5.35-1l-1.56-3,3.36-7.07Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.55 337.75 109.57 341.93 111.86 345.48 119.44 344.29 114.55 337.75",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.77 344.42 115.57 336.22 113.22 337.9 117.72 344.98 120.77 344.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.77 344.42 115.57 336.22 113.22 337.9 117.72 344.98 120.77 344.42",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.89,336.78C80.06,332,74.59,317.5,87.74,315s56.37,21.79,56.37,21.79l-2,6.32-40.92-6.75s11.38,10.3-1.07,9C90.24,344.35,85.65,341.45,82.89,336.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.05 335.21 140.49 343.47 143.05 343.82 145.35 336.69 143.05 335.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.05 335.21 140.49 343.47 143.05 343.82 145.35 336.69 143.05 335.21",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.32,345.3l-1.79-5.47a.47.47,0,0,0-.49-.31l-4.76.47a.77.77,0,0,0-.7.84,1.1,1.1,0,0,0,0,.16c.68,1.95,1.37,3.67,2.17,6.12,1,2.89.36,2.27,1.43,5.69.65,2.06,3.1,1.67,2.93.76-.81-4.14.26-4.95,1.17-6.95A1.8,1.8,0,0,0,113.32,345.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,339.39,147.21,345a.49.49,0,0,0,.21.56l4.23,2.52a.79.79,0,0,0,1.09-.27l.07-.15c.63-2,1.11-3.87,1.95-6.39,1-3,1.08-2.1,2.29-5.57.72-2.1-1.55-3.27-2-2.42-1.86,3.92-3.23,3.93-5.22,5A1.91,1.91,0,0,0,149.06,339.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84,320.75H118.12a2,2,0,0,1-2-2h27.77A2,2,0,0,1,141.84,320.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84,320.75H118.12a2,2,0,0,1-2-2h27.77A2,2,0,0,1,141.84,320.75Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38,320.75H107.15a2,2,0,0,1-2-2h21.28A2,2,0,0,1,124.38,320.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38,320.75H107.15a2,2,0,0,1-2-2h21.28A2,2,0,0,1,124.38,320.75Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,320.13H126.4a.48.48,0,0,1-.45-.64l6.94-19.84a1.37,1.37,0,0,1,1.29-.91h15.61a.48.48,0,0,1,.45.64l-6.94,19.84A1.38,1.38,0,0,1,142,320.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,320.13H126.4a.48.48,0,0,1-.45-.64l6.94-19.84a1.37,1.37,0,0,1,1.29-.91h15.61a.48.48,0,0,1,.45.64l-6.94,19.84A1.38,1.38,0,0,1,142,320.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.62,320.13H127a.48.48,0,0,1-.45-.64l6.94-19.84a1.37,1.37,0,0,1,1.29-.91H150.4a.48.48,0,0,1,.45.64l-6.94,19.84A1.37,1.37,0,0,1,142.62,320.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.62,320.13H127a.48.48,0,0,1-.45-.64l6.94-19.84a1.37,1.37,0,0,1,1.29-.91H150.4a.48.48,0,0,1,.45.64l-6.94,19.84A1.37,1.37,0,0,1,142.62,320.13Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,309.44c-.17.76-.69,1.37-1.18,1.37s-.75-.61-.59-1.37.69-1.38,1.18-1.38S140.19,308.68,140,309.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.86,279.89s3.81,18.76,6.38,21.87S108,313.24,108,313.24l6.66-1.39,4.77,4-3.12,2.46-3.69-1.39a34.65,34.65,0,0,1-6.1.53c-3.44,0-17.41-8.22-20.18-12.84s-6.65-22-6.65-22Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.33,268.53l2.38-1.38,5.8,6.42s-3.19-1.3-4.09-.77-.24,2.53-1.18,2.55C94.15,275.38,93.33,268.53,93.33,268.53Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.51,273.57l3-6,2.48,1.33s2.3,5.81.54,6.42c-1.07.37-1.48-2.34-2.54-2.74C104.17,272.3,101.51,273.57,101.51,273.57Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.33,268.53l2.38-1.38,5.8,6.42s-3.19-1.3-4.09-.77-.24,2.53-1.18,2.55C94.15,275.38,93.33,268.53,93.33,268.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.51,273.57l3-6,2.48,1.33s2.3,5.81.54,6.42c-1.07.37-1.48-2.34-2.54-2.74C104.17,272.3,101.51,273.57,101.51,273.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.06,289.22s-4.41-13.35,1.41-17.87S90,286.75,90,286.75Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.06,289.22s-4.41-13.35,1.41-17.87S90,286.75,90,286.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.88 288.08 79.77 290.37 90.9 287.5 90.45 285.21 78.88 288.08",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.88 288.08 79.77 290.37 90.9 287.5 90.45 285.21 78.88 288.08",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.43,259.36c0-.38-.09-.75-.14-1.11l8.47,6.69a14.11,14.11,0,0,0-.62,2.88C99,267.86,97.08,262.2,96.43,259.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.89,248.49c-1.77,6-2.65,8.49-.78,12.52,2.8,6.13,10.53,7,14,1.66,3.14-4.81,5.56-13.77.65-18.18a8.5,8.5,0,0,0-13.91,4Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,254.49c-.17.47-.06.95.26,1.06s.7-.18.87-.65.06-1-.25-1.07S104.8,254,104.62,254.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,256.44c-.18.48-.06,1,.24,1.07s.71-.18.88-.66.06-1-.25-1.07S110.18,256,110,256.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2,256.58a13.74,13.74,0,0,0,1.37,3.43,2.14,2.14,0,0,1-1.83.11Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.41,251.84a.3.3,0,0,0,.35.06,3.55,3.55,0,0,1,2.83.26.29.29,0,0,0,.4-.12.29.29,0,0,0-.11-.4,4.2,4.2,0,0,0-3.38-.29.3.3,0,0,0-.14.4A.19.19,0,0,0,104.41,251.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.17,255.41a.32.32,0,0,0,.3,0,.31.31,0,0,0,.15-.39,3,3,0,0,0-2.07-1.79.31.31,0,0,0-.11.6,2.37,2.37,0,0,1,1.63,1.42A.41.41,0,0,0,113.17,255.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.72,252a2.07,2.07,0,0,0,1.93-2.61s3.71-.1,3.87-2.82c0,0,3.24,2.87,4.38.63,0,0,4,3.55,4.5,1.2,0,0,4.12,5.12,3.91,2,0,0,4.65-.47.47-4.49,0,0,3.82-3.34-2.35-4.7,0,0,.54-4-3.8-2.22,0,0-1-4.31-4.76-1.8,0,0-2-3-4.26,1,0,0-3.28-1.87-4.32,2.36,0,0-5.93.72-3.49,4.62,0,0,1.83,13.09,3.49,13.09C97.42,258.25,96.72,252,96.72,252Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.68,252.59a4.56,4.56,0,0,0,1.43,3.17c1.16,1.09,2.49.22,2.77-1.26s0-3.52-1.51-4a2,2,0,0,0-2.59,1.29A2,2,0,0,0,94.68,252.59Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.94,261.73a3.46,3.46,0,0,0,.64.13.13.13,0,0,0,.15-.1h0a.13.13,0,0,0-.12-.14,3.52,3.52,0,0,1-2.67-1.73.13.13,0,0,0-.18-.06.13.13,0,0,0-.06.17A3.63,3.63,0,0,0,105.94,261.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,259S41.71,368.41,112.12,370.42c64.22,1.82,49.86-50.65,45.69-54.3s11.48,33.67-14.36,34.2c-31.16.63-36.81-29-47.25-29.24S70,334.65,68.4,309.59,75.05,242,63,259Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,259S41.71,368.41,112.12,370.42c64.22,1.82,49.86-50.65,45.69-54.3s11.48,33.67-14.36,34.2c-31.16.63-36.81-29-47.25-29.24S70,334.65,68.4,309.59,75.05,242,63,259Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about-us.541a932d2edb3d559b61bc5f68a5479c.svg";
export { ForwardRef as ReactComponent };